import React from 'react';
import { MicroFEShell, MicroFEComponent } from '@carvana/microfrontend';

import { config } from './contact-flow-config';

const env = process.env.GATSBY_ACTIVE_ENV === 'prod' ? 'production' : 'test';
const renderLocation = 'support-center';

export const ContactFlowModule = () => {
  return (
    <MicroFEShell config={config} env={env} name="contact-flow-module" ssr>
      <MicroFEComponent module="ContactFlowModule" component="default" renderLocation={renderLocation} />
    </MicroFEShell>
  );
};
